import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/_layout/inventory/asset-safety-inspections"
)({
  component: RouteComponent,
});

function RouteComponent() {
  // AssetSafetyInspectionLogViewSet is a ReadOnlyModelViewSet -- no write
  // route exists at all, so read_permission ("inventory.stock.view") is the
  // only gate that ever applies here, with no degrade-to-own-rows fallback.
  return (
    <ProtectedRoute requiredPermission="inventory.stock.view">
      <AssetSafetyInspectionsPage />
    </ProtectedRoute>
  );
}

import { ProtectedRoute } from "@/components/protected-route";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import PageHeader from "@/components/reusable-components/header/page-header";
import { PaginationComponent } from "@/components/crud/Pagination/Pagination";
import { PAGE_SIZE_OPTIONS } from "@/lib/constants";
import { usePaginationState } from "@/hooks/ui/usePaginationState";
import { useFetchAssetSafetyInspections } from "@/hooks/api/inventory/useAssetSafetyInspections";
import { AssetSafetyInspectionTable } from "@/components/inventory/tables/AssetSafetyInspectionTable";

function AssetSafetyInspectionsPage() {
  const { page, setPage, pageSize, handlePageSizeChange } =
    usePaginationState();

  const inspectionsQuery = useFetchAssetSafetyInspections({
    page_size: pageSize,
    page,
  });
  const inspections = inspectionsQuery.data?.results ?? [];
  const count = inspectionsQuery.data?.count ?? 0;
  const isLoading = inspectionsQuery.isPending;
  const isFetching = inspectionsQuery.isFetching;

  return (
    <SidebarInset>
      <DashboardHeader />

      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="Asset Safety Inspections"
          description="View return inspection results and safety outcomes for serialized assets."
          isLoading={isLoading}
        />

        <AssetSafetyInspectionTable
          inspections={inspections}
          isLoading={isLoading}
        />

        <PaginationComponent
          count={count}
          page={page}
          onPageChange={setPage}
          isLoading={isFetching}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
        />
      </div>
    </SidebarInset>
  );
}
